module.exports = __webpack_public_path__ + "assets/img/w-c-4.a1ad5a99.png";